/**
 * @module Utilities/Helpers
 * @desc Helpers helper funtions
 */

import { STATUS } from 'core/utilities/enums';

/**
 * Presenter status
 */

export function presenterStatus(status: STATUS) {
  const isLoading = status === STATUS.RUNNING;
  const isError = status === STATUS.ERROR;
  const isSuccess = status === STATUS.SUCCESS;
  const isIdle = status === STATUS.IDLE;

  return {
    isError,
    isIdle,
    isLoading,
    isSuccess,
    status,
  };
}
